import * as React from "react";
import { LineStyle, GrafosSymbol } from "../interfaces/element";
const SVG_WIDTH = 16;
const SVG_HEIGHT = 6;
const SVG_RAD = SVG_HEIGHT / 2;
const SVG_STROKE = 1;
export const LegendRow = ({ style, minimal, legendValue, legendDescription, legendLineStyle, legendSymbol, color, yId, toggleVariable, showLabel, }) => {
    const buildLine = (style) => {
        let line;
        switch (style) {
            case LineStyle.solid:
                line = (React.createElement("line", { key: "line", x1: 0, y1: SVG_HEIGHT / 2, x2: SVG_WIDTH, y2: SVG_HEIGHT / 2, stroke: color, strokeWidth: SVG_STROKE }));
                break;
            case LineStyle.dashed:
                line = (React.createElement("line", { key: "line", x1: 0, y1: SVG_HEIGHT / 2, x2: SVG_WIDTH, y2: SVG_HEIGHT / 2, stroke: color, strokeWidth: SVG_STROKE, strokeDasharray: "3,3" }));
                break;
            case LineStyle.dotted:
                line = (React.createElement("line", { key: "line", x1: 0, y1: SVG_HEIGHT / 2, x2: SVG_WIDTH, y2: SVG_HEIGHT / 2, stroke: color, strokeWidth: SVG_STROKE, strokeDasharray: "1,1" }));
                break;
        }
        return line;
    };
    const buildSymbol = (symbol) => {
        const top = (SVG_WIDTH / 2).toString() + ",0";
        const bottom = (SVG_WIDTH / 2).toString() + "," + SVG_HEIGHT.toString();
        switch (symbol) {
            case GrafosSymbol.circle:
                return (React.createElement("circle", { key: "circle", cx: SVG_WIDTH / 2, cy: SVG_HEIGHT / 2, r: SVG_RAD, fill: color }));
            case GrafosSymbol.diamond:
                const centerLeft = (SVG_WIDTH / 2 - SVG_RAD).toString() +
                    "," +
                    (SVG_HEIGHT / 2).toString();
                const centerRight = (SVG_WIDTH / 2 + SVG_RAD).toString() +
                    "," +
                    (SVG_HEIGHT / 2).toString();
                return (React.createElement("polygon", { key: "diamond", points: centerLeft + " " + top + " " + centerRight + " " + bottom, fill: color }));
            case GrafosSymbol.square:
                const topLeft = (SVG_WIDTH / 2 - SVG_RAD).toString();
                const side = SVG_RAD * 2;
                return (React.createElement("rect", { key: "square", x: topLeft, y: "0", width: side, height: side, fill: color }));
            case GrafosSymbol.triangle:
                const bottomLeftTri = (SVG_WIDTH / 2 - SVG_RAD).toString() + "," + SVG_HEIGHT.toString();
                const bottomRightTri = (SVG_WIDTH / 2 + SVG_RAD).toString() + "," + SVG_HEIGHT.toString();
                return (React.createElement("polygon", { key: "triangle", points: top + " " + bottomLeftTri + " " + bottomRightTri, fill: color }));
            case GrafosSymbol.cross:
                return [
                    React.createElement("line", { key: "cross1", x1: SVG_WIDTH / 2 - SVG_RAD, y1: SVG_HEIGHT, x2: SVG_WIDTH / 2 + SVG_RAD, y2: "0", stroke: color, strokeWidth: SVG_STROKE + 1 }),
                    React.createElement("line", { key: "cross2", x1: SVG_WIDTH / 2 + SVG_RAD, y1: SVG_HEIGHT, x2: SVG_WIDTH / 2 - SVG_RAD, y2: 0, stroke: color, strokeWidth: SVG_STROKE + 1 }),
                ];
            case GrafosSymbol.plus:
                return [
                    React.createElement("line", { key: "plus1", x1: SVG_WIDTH / 2, y1: SVG_HEIGHT, x2: SVG_WIDTH / 2, y2: "0", stroke: color, strokeWidth: SVG_STROKE + 1 }),
                    React.createElement("line", { key: "plus2", x1: SVG_WIDTH / 2 - SVG_RAD, y1: SVG_HEIGHT / 2, x2: SVG_WIDTH / 2 + SVG_RAD, y2: SVG_HEIGHT / 2, stroke: color, strokeWidth: SVG_STROKE + 1 }),
                ];
            default:
                return null;
        }
    };
    const line = buildLine(legendLineStyle);
    const symbol = legendSymbol ? buildSymbol(legendSymbol) : null;
    const opacity = legendValue ? "1" : "0.25";
    let className = "legend-variable";
    if (minimal)
        className += " legend-variable-min";
    if (toggleVariable)
        className += " legend-clickable";
    return (React.createElement("div", { className: className, style: style, onClick: toggleVariable },
        React.createElement("svg", { height: SVG_HEIGHT, width: SVG_WIDTH, className: "legend-svg" },
            React.createElement("g", { strokeOpacity: opacity, fillOpacity: opacity },
                line,
                symbol)),
        React.createElement("span", { className: legendValue ? "" : "legend-disabled" }, legendDescription),
        yId && showLabel && (React.createElement("span", { className: `yAxis-identifier ${legendValue ? "" : "legend-disabled"}` },
            "(",
            yId,
            ")"))));
};
//# sourceMappingURL=LegendRow.js.map